import UserForms from './modules/user-forms';
import AjaxButtons from './modules/ajax-button';
import Entries from './modules/entries';
import ConditionalFields from './modules/conditional-fields';

new UserForms();
AjaxButtons();
Entries();
ConditionalFields();
